module.exports = __webpack_public_path__ + "static/media/website-12.03872b14.mp4";